// ページ内アンカーリンクのスクロールエフェクト // Scrolling effect for anchor links within the page
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定) // Set header height to headerHight if header is fixed (PC/SP setting required)
if ('scrollRestoration' in history) {
	history.scrollRestoration = 'manual';
}

jQuery(function ($) {

	// クリック時（同一ページ）
	$('a[href*="#"]').on('click', function (e) {
		const href = $(this).attr('href');
		const url = new URL(href, location.href);

		if (!url.hash) return;

		if (url.pathname === location.pathname) {
			const target = $(url.hash);
			if (target.length) {
				e.preventDefault();
				const headerHeight = 60;
				const pos = target.offset().top - headerHeight;
				$('html, body').stop().animate({ scrollTop: pos }, 550, 'swing');
			}
		}
	});
});

// ページ完全読み込み後（別ページからの遷移）
jQuery(window).on('load', function () {
	const hash = location.hash;
	if (!hash) return;

	const $target = jQuery(hash);
	if (!$target.length) return;

	const headerHeight = jQuery('header').innerHeight();
	const pos = $target.offset().top - headerHeight;

	// 即座に移動（animate不要）
	jQuery('html, body').scrollTop(pos);
});